module.exports = __webpack_public_path__ + "static/media/mission-statement-workl.e3117fb8.svg";